import React, { createContext, useContext, ReactNode } from "react";

interface ThemeColorContextValue {
  themeColor: string;
  setThemeColor: (color: string) => void;
  /** Resolved from /api/client/theme before login (subdomain tenant) */
  publicCompanyName: string | null;
  publicLogoPath: string | null;
}

const ThemeColorContext = createContext<ThemeColorContextValue | null>(null);

type ThemeColorProviderProps = Readonly<{
  children: ReactNode;
  themeColor: string;
  setThemeColor: (color: string) => void;
  publicCompanyName?: string | null;
  publicLogoPath?: string | null;
}>;

export function ThemeColorProvider({
  children,
  themeColor,
  setThemeColor,
  publicCompanyName = null,
  publicLogoPath = null,
}: ThemeColorProviderProps) {
  const value = React.useMemo(
    () => ({
      themeColor,
      setThemeColor,
      publicCompanyName,
      publicLogoPath,
    }),
    [themeColor, setThemeColor, publicCompanyName, publicLogoPath]
  );
  return (
    <ThemeColorContext.Provider value={value}>
      {children}
    </ThemeColorContext.Provider>
  );
}

export function useThemeColor(): ThemeColorContextValue | null {
  return useContext(ThemeColorContext);
}
